import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { useDealerTheme } from '../../../hooks/useDealerTheme';
import {
  LabelAndValues,
  useHeight,
  useLabelAndValue,
  useNumberLabelAndNumber,
} from '../../../hooks/useHeight';
import { isArray } from 'lodash';

type OverviewModulmoebelTableProps = {
  usps?: string[];
};

const OverviewModulmoebelTable = ({ usps }: OverviewModulmoebelTableProps) => {
  const { variableFontColor } = useDealerTheme();

  const model = useLabelAndValue('model');
  const corpusDecor = useLabelAndValue('corpusDecor');
  const frontDecor = useLabelAndValue('frontDecor');
  const height = useHeight();
  const depth = useNumberLabelAndNumber('depth');
  const width = useNumberLabelAndNumber('width');

  const data = useMemo(() => {
    const d: LabelAndValues[] = [];
    d.push(model);
    d.push(depth, height, width);
    d.push(corpusDecor, frontDecor);

    return d.map((e) => ({
      ...e,
      value: isArray(e.value) ? e.value : [e.value],
    }));
  }, [corpusDecor, frontDecor, width]);

  return (
    <Stack>
      <Stack mb={2}>
        {usps && usps.length > 0 && (
          <>
            {usps.map((usp) => (
              <Typography
                key={usp}
                sx={{ color: variableFontColor, lineHeight: '2rem' }}
              >
                <Typography
                  component="span"
                  sx={{ fontWeight: 'bold', fontFamily: 'montserrat' }}
                >
                  {'\u2714 '}
                </Typography>
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  {' '}
                  {usp}
                </Typography>
              </Typography>
            ))}
          </>
        )}
      </Stack>
      <Typography
        sx={{
          color: variableFontColor,
          lineHeight: '2rem',
          fontWeight: 'bold',
        }}
      >
        Alle Daten auf einen Blick:
      </Typography>
      <div>
        {data.map((d, i) => (
          <Stack
            key={d.variable}
            sx={{
              width: '100%',
              backgroundColor: i % 2 ? undefined : '#f6f6f6',
              p: 0.5,
              flexDirection: 'row',
            }}
          >
            <Typography
              component="span"
              sx={{
                width: '60%',
                display: 'inline-block',
              }}
            >
              {d.variable}
            </Typography>
            {d.value.map((v, i) => (
              <Typography
                key={i}
                component="span"
                sx={{
                  width: `${50 / d.value.length}%`,
                  display: 'inline-block',
                }}
                dangerouslySetInnerHTML={{ __html: v }}
              />
            ))}
          </Stack>
        ))}
      </div>
    </Stack>
  );
};

export { OverviewModulmoebelTable };
